import FormHelperText from "@mui/material/FormHelperText";
import { FormikErrors, FormikTouched } from "formik";
import { ReactNode } from "react";

export interface InputErrorReturnType {
  error: boolean;
  helperText: string;
  /** Id of the rendered message; put it in the field's `aria-describedby` while `error`. */
  errorId: string;
  /** `errorId` while there is an error, otherwise undefined: spread into `aria-describedby`. */
  describedBy: string | undefined;
  display: ReactNode | null;
}

/** Formik field error state plus a themed helper-text node for custom field layouts. */
export const inputError = <Values,>(
  inputName: keyof Values & string,
  touched: FormikTouched<Values>,
  errors: FormikErrors<Values>,
  noTouch = false,
): InputErrorReturnType => {
  const message = errors?.[inputName];
  const text = typeof message === "string" ? message : "";
  const visible = noTouch ? !!message : !!touched?.[inputName] && !!message;
  const errorId = `${inputName}-error`;

  return {
    error: visible,
    helperText: visible ? text : "",
    errorId,
    describedBy: visible ? errorId : undefined,
    display: visible ? (
      <FormHelperText
        id={errorId}
        error
        role="alert"
        sx={(theme) => ({
          ml: 0,
          color: theme.palette.error.main,
          fontSize: theme.typography.body2.fontSize,
        })}
      >
        {text}
      </FormHelperText>
    ) : null,
  };
};
